import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
`;

export const ModalTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #303030;
  margin: 0 0 24px 0;
  text-align: center;
`;

export const ItemTypesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 24px;
`;

export const ItemTypeButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px;
  border: 2px solid #EBEBEB;
  border-radius: 12px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Inter', sans-serif;

  &:hover {
    border-color: #0090D3;
    background-color: #f8fafb;
  }
`;

export const ItemTypeIcon = styled.div`
  color: #0090D3;
`;

export const ItemTypeTitle = styled.h4`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #303030;
  margin: 0;
  text-align: center;
`;

export const ItemTypeDescription = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: #696969;
  margin: 0;
  text-align: center;
  line-height: 1.4;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
`; 